<template>
  <div class="modal-card">
    <b-loading isFullPage :active="isLoading" />
    <div class="card-body">
      <h2 class="has-text-weight-semibold subtitle my-15">
        {{ General.PROFILE }}
      </h2>
    </div>
    <div class="card-body">
      <h2 class="has-text-weight-medium subtitle mb-0 is-size-6">
        {{ General.TEXTS.MANDATORY_PROFILE }}
      </h2>
    </div>
    <section class="profiles-list">
      <div
        class="three-column"
        :class="{ 'is-flex is-justify-content-space-between': !listAll }"
      >
        <b-radio
          v-for="profile in mandatoryProfiles"
          :key="profile.id"
          v-model="mandatoryProfileSelect"
          :nativeValue="profile.id"
          :type="isContrast ? 'is-white' : 'is-primary'"
          class="has-text-color-7"
          @input="checkList"
        >
          <span class="mr-10">{{ profile.name }}</span>
        </b-radio>
      </div>
    </section>
    <div class="card-body">
      <h2 class="has-text-weight-medium subtitle mb-0 is-size-6">
        {{ General.TEXTS.ADDITIONAL_PROFILE }}
      </h2>
      <div class="marks">
        <b-button type="is-text" @click="selectAll">
          {{ "Selecionar todos" }}
        </b-button>
        <span class="division">|</span>
        <b-button type="is-text" @click="deselectAll">
          {{ "Desmarcar todos" }}
        </b-button>
      </div>
    </div>
    <section class="profiles-list custom-overflow-y">
      <div class="two-column">
        <div
          v-for="profile in additionalProfiles"
          :key="profile.id"
          class="checkbox-item"
        >
          <b-tooltip
            :active="!profile.can_assign"
            :label="General.YOU_DONT_HAVE_PERMISSION_TO_CHANGE_PROFILE"
            position="is-right"
            :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
            size="is-small"
            role="tooltip"
            :multilined="isMobile"
            appendToBody
          >
            <b-checkbox
              v-model="permissionsInner[profile.id]"
              :disabled="!profile.active || !profile.can_assign"
              :indeterminate="
                (!profile.active || !profile.can_assign) &&
                  permissionsInner[profile.id]
              "
              :type="!profile.active ? 'is-grey-light' : checkboxColor"
            >
            </b-checkbox>
          </b-tooltip>
          <span
            class="has-text-color-7 mr-10"
            :class="{
              'custom-opacity': !profile.active || !profile.can_assign
            }"
            >{{ profile.name }}</span
          >
        </div>
      </div>
    </section>
    <div class="buttons is-align-self-flex-end mr-30 ">
      <b-button
        :type="isContrast ? 'is-white' : 'is-green-lawn'"
        @click="confirmAction"
      >
        {{ General.SAVE }}
      </b-button>
      <b-button
        outlined
        :type="isContrast ? 'is-white' : 'is-orange'"
        @click="close"
      >
        {{ General.CANCEL }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { General } from "@/utils/constants";

export default {
  name: "ModalProfileList",

  props: {
    partId: {
      required: true,
      type: Number
    },
    permissions: {
      required: true,
      type: Array
    },
    confirm: {
      required: true,
      type: Function
    },
    addDefault: {
      type: Object,
      default: () => {}
    },
    defaultProfile: {
      type: Object,
      default: () => {}
    },
    listAll: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      General,
      isLoading: false,
      permissionsInner: [],
      mandatoryProfileSelect: 0,
      plusProfile: undefined
    };
  },

  computed: {
    ...mapGetters({
      getProfilesByPart: "getProfilesByPart",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    mandatoryProfiles() {
      let profiles = this.getProfilesByPart.filter(profile =>
        profile.name.match(/Default/)
      );
      const actualDefault = profiles?.find(
        profile =>
          this.permissionsInner[profile.id] && profile.name.match(/Default/)
      )?.id;
      if (!this.listAll)
        profiles = profiles.filter(
          profile => profile.id === (this.defaultProfile?.id || actualDefault)
        );
      if (this.plusProfile && !actualDefault) {
        const alreadyExists = profiles.some(
          profile => profile.id === this.plusProfile
        );
        if (!alreadyExists) {
          const plusProfiles = this.getProfilesByPart.find(
            profile => profile.id === this.plusProfile
          );
          profiles.push(plusProfiles);
        }
      }
      return profiles;
    },

    additionalProfiles() {
      return this.getProfilesByPart.filter(
        profile => !profile.name.match(/Default/)
      );
    },

    checkboxColor() {
      return this.isContrast ? "is-white" : "is-blue-oil";
    }
  },

  watch: {
    getProfilesByPart() {
      const profileId = this.defaultProfile?.id;
      this.permissions.map(permission => {
        this.permissionsInner[permission.id] = true;
        if (permission.name.match(/Default/) && !profileId)
          this.mandatoryProfileSelect = permission.id;
      });
      !this.mandatoryProfileSelect && (this.mandatoryProfileSelect = profileId);
      profileId && (this.permissionsInner[profileId] = true);
    }
  },

  async beforeMount() {
    this.isLoading = true;
    if (this.partId)
      await this.profileRequestByPart({ part: this.partId, simple: true });
    if (this.addDefault.capacity_id && !this.listAll) {
      this.getDefaultByCapacity(this.addDefault.capacity_id).then(result => {
        this.plusProfile = result.data.id;
      });
    }
    this.isLoading = false;
  },

  methods: {
    ...mapActions(["getDefaultByCapacity", "profileRequestByPart"]),
    confirmAction() {
      const permissionsSelect = this.getProfilesByPart.filter(
        permission => this.permissionsInner[permission.id]
      );
      this.confirm(permissionsSelect);
      this.close();
    },
    close() {
      this.$parent.close();
    },
    selectAll() {
      const profilesToSelect = [...this.permissionsInner];
      this.additionalProfiles.forEach(perfil => {
        if (perfil.can_assign) {
          profilesToSelect[perfil.id] = true;
        }
      });
      this.permissionsInner = profilesToSelect;
    },
    deselectAll() {
      const profilesToKeep = [...this.permissionsInner];
      this.additionalProfiles.forEach(perfil => {
        if (perfil.can_assign) {
          profilesToKeep[perfil.id] = null;
        }
      });
      this.permissionsInner = profilesToKeep;
    },
    checkList(newMandory) {
      this.permissionsInner[newMandory] = true;
      this.mandatoryProfiles.find(
        profile =>
          profile.id !== newMandory &&
          (this.permissionsInner[profile.id] = false)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.modal-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  min-height: 320px;
  max-height: 80vh;
  background-color: $color-1;

  @media screen and (min-width: $tablet) {
    min-width: 700px;
    width: auto;
  }
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 30px;

  .marks {
    &::before {
      content: "(";
      top: 6px;
      position: relative;
      color: $color-7;
    }
    &::after {
      content: ")";
      top: 6px;
      position: relative;
      color: $color-7;
    }
    .button {
      padding-left: 0;
      padding-right: 0;
      text-decoration: none;
      color: $color-7;

      &:hover {
        background-color: $color-2;
      }
    }
    .division {
      padding: 0 5px;
      top: 6px;
      position: relative;
    }
  }
}
.profiles-list {
  width: 100%;
  padding: 0 20px;
  margin: 15px 0;

  .three-column {
    padding-left: 10px;
    column-count: 3;
    border-bottom: 1px solid $border-color;
    @media screen and (max-width: 450px) {
      column-count: 2;
    }

    .b-radio {
      display: flex;
      margin-bottom: 20px;
    }
  }

  .two-column {
    column-count: 2;
    @media screen and (max-width: 450px) {
      column-count: 1;
    }

    .checkbox-item {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      width: 100%;
      margin-bottom: 20px;

      .tooltip-trigger {
        display: flex;
      }
    }
  }
}

.custom-overflow-y {
  overflow-y: auto;
}
</style>
